var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKaPedikuere(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#f8c9af;}.cls-4{fill:#f0a88f;}.cls-5{fill:#d2f1f7;}.cls-6{fill:#96e5ff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 14.18,
    y: 8,
    width: 134.09,
    height: 144
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Maske"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 160,
    height: 160,
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M147.63,131.16a94.06,94.06,0,0,1-3.6-25.78V15.17A7.18,7.18,0,0,0,136.86,8H110.42a7.18,7.18,0,0,0-7.17,7.17V110a2.94,2.94,0,0,1-1.7,2.66L79.36,122.83a55,55,0,0,1-23.13,5.06,7.16,7.16,0,0,0-5.12,12.18l2.79,2.85a30.37,30.37,0,0,0,26.32,8.72l25.42-4,33.07-3.36a10.36,10.36,0,0,0,8.92-13.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M147.63,131.16a94.06,94.06,0,0,1-3.6-25.78V15.17A7.18,7.18,0,0,0,136.86,8h-8.49a7.18,7.18,0,0,1,7.17,7.17v90.21a94.06,94.06,0,0,0,3.6,25.78,10.38,10.38,0,0,1-1.39,8.66c-1.69,2.49-4.36,5-7.34,5.32h0l8.3-.84a10.36,10.36,0,0,0,8.92-13.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M113.43,96.34A12.85,12.85,0,0,0,104.5,92c-.4,0-.8,0-1.2,0a10.89,10.89,0,0,0-10-8.4,11.28,11.28,0,0,0-3.43.35,18.42,18.42,0,0,0-34.19-2.2A12.39,12.39,0,0,0,53,81.29,12.22,12.22,0,0,0,40.13,92.78c0,.15,0,.29,0,.44a13.66,13.66,0,0,0-5.45,25.63A11.78,11.78,0,0,0,39,120.27a15.65,15.65,0,0,0,2.15.15,13.49,13.49,0,0,0,7.5-2.26,12.94,12.94,0,0,0,12.63-.07,13,13,0,0,0,15.42-2.8A13,13,0,0,0,95,114.5a13.19,13.19,0,0,0,13.55,2.58,12,12,0,0,0,6.84-6.26,13.13,13.13,0,0,0-2-14.48Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M113.43,96.34A12.85,12.85,0,0,0,104.5,92c-.4,0-.8,0-1.2,0a10.89,10.89,0,0,0-10-8.4,11.28,11.28,0,0,0-3.43.35A18.33,18.33,0,0,0,73.45,71.23a18.61,18.61,0,0,0-5.29.47A18.29,18.29,0,0,1,81.43,84a11.25,11.25,0,0,1,3.43-.35,10.9,10.9,0,0,1,10,8.4c.4,0,.8,0,1.2,0a13,13,0,0,1,3.5,25.18,13.17,13.17,0,0,0,3.51.69,13,13,0,0,0,10.41-21.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M54.43,52.11a9,9,0,1,0,9,9,9,9,0,0,0-9-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M72.1,36.18A7.83,7.83,0,1,0,79.94,44a7.84,7.84,0,0,0-7.84-7.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M54.43,40.42a7.83,7.83,0,1,0-7.83-7.83,7.84,7.84,0,0,0,7.83,7.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M54.43,52.11a9,9,0,0,0-4.25,1.06,9,9,0,0,1,0,15.91,9,9,0,1,0,4.25-17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M72.1,36.18a7.79,7.79,0,0,0-4.24,1.25,7.83,7.83,0,0,1,0,13.16A7.83,7.83,0,1,0,72.1,36.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M54.43,24.76A7.84,7.84,0,0,0,50.18,26a7.83,7.83,0,0,1,0,13.16,7.83,7.83,0,1,0,4.25-14.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M125.92,106.93a2.12,2.12,0,0,1-1-4c2.85-1.62,1-6.82.95-6.87a2.12,2.12,0,0,1,4-1.52,15.36,15.36,0,0,1,.89,4.44c.16,3.48-1.15,6.19-3.71,7.64a2.08,2.08,0,0,1-1,.28Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKaPedikuere);
export default __webpack_public_path__ + "static/media/ka_pedikuere.8ba9e1955071e02310ac7dc217108277.svg";
export { ForwardRef as ReactComponent };